import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { injectTestId } from '@cvent/nucleus-test-automation';
import TimeZoneSwitchWidgetStyles from './TimeZoneSwitchWidget.less';
import Icon from '@cvent/nucleus-icon';

const TimeStyles = {
  classes: TimeZoneSwitchWidgetStyles
};

/**
 *
 * Time Zone switch widget shows in which time zone you are
 * currently viewing the event, for example
 * Viewing in Eastern Time etc.
 * It also provides the functionality to adjust your time zone
 *
 */
const TimeZoneSwitchWidget = (props) => {
  const { translate, switchTimeZone, instructionalTextStyles, showTimeZoneWidget, selectedTimeZone,
    eventTimeZone, hideAdjustTimeZone, isEventAndDeviceTimeZoneOffSetSame } = props;
  const timeZone = selectedTimeZone && selectedTimeZone.nameResourceKey ? translate(selectedTimeZone.nameResourceKey) :
    translate(eventTimeZone.nameResourceKey);
  const timeZoneText = translate('Event_GuestSide_TimeZone_ViewText__resx', { timeZone });

  return (
    <React.Fragment>
      {
        showTimeZoneWidget && <div {...resolve(props, instructionalTextStyles)} {...injectTestId('timeZoneWidget')}>
          <Icon icon="time" modifier={TimeZoneSwitchWidgetStyles.timeIconSize}/>
          {timeZoneText}
          {!hideAdjustTimeZone && !isEventAndDeviceTimeZoneOffSetSame && <span
            {...resolve(TimeStyles, 'switchStyle')} {...injectTestId('switchButton')}
            onClick={switchTimeZone}>
            <u>{translate('Event_GuestSide_SwitchText__resx')}</u>
          </span>}
        </div>
      }
    </React.Fragment>
  );
};

export default TimeZoneSwitchWidget;
